module.exports = __webpack_public_path__ + "static/media/regwiz_117.9ad505da.ico";